import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Singers from "../views/Singers/Singers.js";
import UsersPage from "../views/Users/users.js";
import TransactionPage from "../views/Transaction/transaction.js";
import Categories from "../views/Categories/Categories.js";
import Advertising from "../views/Advertising/Advertising.js";
import Plans from "../views/Plans/Plans.js";
import Songs from "../views/Songs/Songs.js";
import NotFound from "../views/NotFound/NotFound.js";
import LoginPage from "../views/Login.js";
import DashboardPage from "../views/Dashboard/Dashboard.js";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
/****End Layouts*****/

/*****Routes******/

const ThemeRoutes = [
  {

    path: "/login",
    element: <LoginPage />,
  },
  {

    path: "*", element: <NotFound />
  }, // Add this line for the NotFound route

  {

    path: "/",
    element: <FullLayout />,
    children: [
      { path: "/", element: <Navigate to="/songs" /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/singers", element: <Singers /> },
      { path: "/users", element: <UsersPage /> },
      { path: "/transaction", element: <TransactionPage /> },
      { path: "/categories", element: <Categories /> },
      { path: "/advertising", element: <Advertising /> },
      { path: "/plans", element: <Plans /> },
      { path: "/songs", exact: true, element: <Songs /> },
    ],
  },
];

export default ThemeRoutes;
